// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2_zqU","content":"RecentSearches_content__2ZaPj"};